import React from 'react';

import classNames from 'classnames';

import styles from './styles.module.scss';

export const FormItem: React.FC<components.FormItem> = ({
  data: { id, title, validation, maxLength, selectData },
  register,
  errors,
  handleChange,
  value,
}) => (
  <>
    <label htmlFor={id}>
      {title}
      {selectData ? (
        <select
          className={classNames(styles.select, { [styles.errorInput]: !!errors.title?.message })}
          id={id}
          {...register(id, { ...validation })}
        >
          {selectData.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      ) : (
        <input
          className={errors[id]?.message && styles.errorInput}
          {...register(id, { ...validation })}
          id={id}
          type="text"
          onChange={handleChange}
          value={value}
          maxLength={maxLength}
        />
      )}
    </label>
    {errors[id]?.message && <p className={styles.errorMessage}>{errors[id].message}</p>}
  </>
);
